import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StraussGeschenk from "../pages/strauss-geschenk/page";
import Hochzeit from "../pages/hochzeit/page";
import Trauer from "../pages/trauer/page";
import Event from "../pages/event/page";
import Pflanzen from "../pages/pflanzen/page";
import UeberUns from "../pages/ueber-uns/page";
import Kontakt from "../pages/kontakt/page";
import Impressum from "../pages/impressum/page";
import Datenschutz from "../pages/datenschutz/page";
import KiTransparenz from "../pages/ki-transparenz/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/strauss-geschenk", element: <StraussGeschenk /> },
  { path: "/hochzeit", element: <Hochzeit /> },
  { path: "/trauer", element: <Trauer /> },
  { path: "/event", element: <Event /> },
  { path: "/pflanzen", element: <Pflanzen /> },
  { path: "/ueber-uns", element: <UeberUns /> },
  { path: "/kontakt", element: <Kontakt /> },
  { path: "/impressum", element: <Impressum /> },
  { path: "/datenschutz", element: <Datenschutz /> },
  { path: "/ki-transparenz", element: <KiTransparenz /> },
  { path: "*", element: <NotFound /> },
];

export default routes;